// Exportação CSV das candidatas do scanner Alpha (FAT-30). Só lê as linhas já exibidas; não envia ordens.
const fmt = valor => Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const reais = valor => Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// Retorno do IBOV com sinal (+4,32%); sem dado = "—", nunca 0. Mesmo texto no cabeçalho do scanner e no "Por que apareceu?" (FAT-47).
export const percentualAlpha = valor => (valor != null && Number.isFinite(Number(valor))
  ? `${Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay: 'always' })}%`
  : '—');

// FAT-45: posição no ranking (só entre as que passaram nos filtros). Sem ranking (volatilidade não calculável) = null.
export function rankingAlpha(linha) {
  const n = linha.totalRanking;
  if (linha.ranking == null || !n) return null;
  return `${linha.ranking}ª em menor volatilidade entre ${n === 1 ? '1 candidata' : `as ${n} candidatas`}`;
}

// Motivo da saída/posição (FAT-45): dados vêm do backend (`linha.posicao`), o texto é montado aqui.
function motivoPosicao(linha, parametros) {
  const p = linha.posicao;
  const partes = [];
  if (p.motivosSaida.includes('rsi')) {
    partes.push(`RSI semanal ${fmt(p.rsiSemanalSaida)} acima de ${parametros?.limiarRsiSaida ?? 'o limite de saída'}`);
  }
  if (p.motivosSaida.includes('perda')) {
    partes.push(`fechamento ${reais(p.fechamento)} abaixo do limite de perda ${reais(p.limitePerda)}`);
  }
  const entrada = `entrada de referência ${reais(p.precoEntrada)} em ${p.dataEntrada.split('-').reverse().join('/')}`;
  return partes.length ? `Saída sinalizada: ${partes.join('; ')} (${entrada})` : `Em posição: ${entrada}`;
}

// Texto explicativo mostrado na tela e gravado no CSV (a mesma função nos dois lugares).
export function motivoAlpha(linha, parametros) {
  if (linha.posicao) return motivoPosicao(linha, parametros);
  if (linha.situacao !== 'Candidata') return linha.situacao;
  const limite = parametros?.limiteRsiSemanal;
  const partes = [`RSI semanal ${fmt(linha.rsiSemanal)}${limite != null ? ` abaixo de ${limite}` : ''}`, 'mercado favorável', 'liquidez elegível'];
  if (linha.volatilidade != null && Number.isFinite(Number(linha.volatilidade))) partes.push(`volatilidade ${fmt(linha.volatilidade)}%`);
  const ranking = rankingAlpha(linha);
  if (ranking) partes.push(ranking);
  return `${linha.estado || 'Candidata'}: ${partes.join('; ')}`;
}

export function escaparCsv(valor) {
  const texto = valor == null ? '' : String(valor);
  return /[",;\r\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}

export function candidatasAlpha(dados) {
  return (dados?.linhas || []).filter(l => l.situacao === 'Candidata');
}

export function nomeArquivoCandidatas(data) {
  return `candidatas-alpha-${data}.csv`;
}

// Devolve null sem candidatas ou sem data (nunca um CSV vazio/só cabeçalho). UTF-8 com BOM para o Excel.
export function montarCsvCandidatas(dados) {
  const candidatas = candidatasAlpha(dados);
  if (!dados?.data || !candidatas.length) return null;
  const linhas = [['data da semana', 'ativo', 'motivo'],
    ...candidatas.map(l => [dados.data, l.ativo, motivoAlpha(l, dados.parametros)])];
  return `﻿${linhas.map(l => l.map(escaparCsv).join(',')).join('\r\n')}\r\n`;
}

export function baixarCsvCandidatas(dados) {
  const csv = montarCsvCandidatas(dados);
  if (csv == null) return false;
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeArquivoCandidatas(dados.data);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return true;
}
